import clsx from 'clsx';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';

import DesktopBanner from '../../../../assets/images/referral/desktop_banner.png';
import MobileBanner from '../../../../assets/images/referral/mobile_banner.png';
import AllAccessIcon from 'images/subscribe-icon-all-access.svg';

import {
  DEFAULT_ANNUAL_PRICE,
  DISCOUNTED_REFERRAL_PRICE,
} from '../../../utils/backend-api/subscribe';
import SubscriptionOptionCard from '../../shared/SubscriptionOptionCard';
import styles from './planOptions.module.scss';

const PlanOptions = ({ referringSubName }: { referringSubName?: string }) => {
  const { width } = useWindowSize();
  const cardsProps = {
    benefits: [
      '<span class="--red">Reporting you won&#39;t find elsewhere</span>',
      'Connect with subscribers in Directory & Forum',
      'A yearly subscription',
    ],
    buttonProps: {
      children: null,
      rounded: 'full' as const,
      variant: 'primary' as const,
    },
    icon: AllAccessIcon,
    price: DISCOUNTED_REFERRAL_PRICE,
    title: 'Annual' as const,
    subtitle: '14-Day Free Trial, then',
    buttonText: 'selected',
    originalPrice: `<span class=${styles.orginalPrice}>$${DEFAULT_ANNUAL_PRICE}/year</span>`,
  };
  return (
    <div className={styles.subscriptionHeaderContainer}>
      <div className={clsx(styles.actionContainer)}>
        <img src={width > 768 ? DesktopBanner : MobileBanner} width="100%" />
        <div className={clsx(styles.sectionWrapper, 'row')}>
          <div
            className={clsx(
              styles.sectionHeader,
              'col-xs-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3'
            )}
          >
            {referringSubName && (
              <>
                <strong>{referringSubName}</strong> has shared 14 days of free access to the best
                news in tech.
              </>
            )}
          </div>
          <div className={clsx(styles.cardWrapper, 'col-xs-12')}>
            <div className={styles.cardContainer} id={cardsProps.title} key={cardsProps.title}>
              <SubscriptionOptionCard {...cardsProps} customStyles={styles.cardStyles} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanOptions;
